import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { SelectShowRequest } from 'components/Tables/ImportTable/SelectedTabRequest';
import { useStyles } from './styles';
// import { useStore } from 'hooks/useRootStore';
// import { useQuery } from 'react-query';
// import { useAppPreloader } from 'hooks/useAppPreloader';

const ImportInvite: FC = observer(() => {
  const classes = useStyles();
  // const {
  //   ldapStore: { getSync, syncs },
  //   notificationStore: { openNotification },
  // } = useStore();
  // const getSyncReq = useQuery('getDeprtmentsReq', () => getSync(), {
  //   onError: () => openNotification('error', `Can't get departments`),
  // });
  // useAppPreloader(getSyncReq.isFetching);
  return (
    <>
      {/* <Container maxWidth='xl'>
        <div>
          {syncs.some((item) => item.people === 0 || item.department === 0 || item.group === 0) ? (
            <h1 className={classes.sync}> Sync in Progress</h1>
          ) : null}
        </div>
      </Container> */}
      <Container maxWidth='xl' className={classes.container}>
        <SelectShowRequest />
      </Container>
    </>
  );
});

export default ImportInvite;
